import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { PainelAjudaComponent } from './painel-ajuda.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [CommonModule, MatCardModule, MatTableModule],
  exports: [PainelAjudaComponent],
  declarations: [PainelAjudaComponent],
  providers: [],
})
export class PainelAjudaModule {}
